import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
  getFunctions,
  httpsCallable,
  connectFunctionsEmulator,
} from "firebase/functions";
import * as firebaseui from "firebaseui";
import {
  getAuth,
  connectAuthEmulator,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  AuthErrorCodes,
  createUserWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import {
  getFirestore,
  connectFirestoreEmulator,
  doc,
  updateDoc,
  collection,
  setDoc,
  getDoc,
  getDocs,
  Timestamp,
  query,
  where,
  serverTimestamp,
  onSnapshot,
} from "firebase/firestore";
import {
  openWorkshops,
  userWorkshops,
  selectedWorkshopID,
  user,
  activeWorkshop,
  activeLesson,
  portalStatus,
} from "./stores.js";
import { subscribe } from "svelte/internal";
import { get } from "svelte/store";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCdTSDLX8QYmvdJ2ylRIXimJE237jXooLs",
  authDomain: "synthase-web-app.firebaseapp.com",
  projectId: "synthase-web-app",
  storageBucket: "synthase-web-app.appspot.com",
  messagingSenderId: "1035973523338",
  appId: "1:1035973523338:web:552aec83dffca79339fa73",
  measurementId: "G-N3BL1W3VMW",
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);
export const analytics = getAnalytics(firebaseApp);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
const functions = getFunctions(firebaseApp);
const syncContactServer = httpsCallable(functions, "syncContact");
// connectAuthEmulator(auth, "http://localhost:9099");
// connectFirestoreEmulator(db, "127.0.0.1", 5007);
// connectFunctionsEmulator(functions, "localhost", 5001);
export const firebaseUI = new firebaseui.auth.AuthUI(auth);
export const workshopPath = "services/workshops/info_public";
const approvalPath = `services/workshops/approved_users`;
export const workshopRef = collection(db, workshopPath);
export const signupPath = "users";

let loginEmail, loginPassword;

export const portalSub = (workshopId) => {
  console.log(workshopId);
  return onSnapshot(doc(db, workshopPath, workshopId), (wsDoc) => {
    // should this be exists()?
    if (wsDoc.exists) {
      const portalOpen = wsDoc.data().portalOpen;
      portalStatus.set({ [`${workshopId}`]: portalOpen });
      const curStatus = get(portalStatus);
      console.log(curStatus);
    }
  });
};

export const checkForApprovedUser = async (emailIn) => {
  const docRef = doc(db, approvalPath, emailIn);
  const approvalDoc = await getDoc(docRef);
  if (approvalDoc.exists()) {
    return approvalDoc.data();
  } else {
    return undefined;
  }
};

export const checkIfUserExists = async (userId) => {
  const userPath = "users";
  console.log(userId);
  const docRef = doc(db, userPath, userId);
  const userDoc = await getDoc(docRef);
  console.log(userDoc.exists());
  return userDoc.exists();
};

export const openWorkshopsUnsub = () => {
  // because the timestamp doesn't refresh, a workshop won't disappear just because it has passed (without a refresh)
  let curTimeFS = Timestamp.fromDate(new Date());
  const q = query(
    workshopRef,
    where("startTime", ">", curTimeFS),
    where("enrollmentStatus", "in", ["open", "almost full"])
  );
  return onSnapshot(q, (querySnapshot) => {
    const openWorkshopsLocal = {};
    querySnapshot.forEach((doc) => {
      openWorkshopsLocal[doc.id] = {
        ...doc.data(),
        id: doc.id,
      };
    });
    openWorkshops.set(openWorkshopsLocal);
  });
};

export const userWorkshopsUnsub = () => {
  const userLocal = get(user);
  let userID;
  if (userLocal.loggedIn) {
    userID = userLocal.uid;
  }
  const userWorkshopPath = `users/${userID}/workshops`;
  const q = query(collection(db, userWorkshopPath));
  return onSnapshot(q, (querySnapshot) => {
    const userWorkshopsLocal = {};
    if (!querySnapshot.empty) {
      querySnapshot.forEach((doc) => {
        userWorkshopsLocal[doc.id] = {
          ...doc.data(),
          id: doc.id,
        };
      });
    }
    userWorkshops.set(userWorkshopsLocal);
  });
};

export const activeWorkshopUnsub = () => {
  const userLocal = get(user);
  const workshopID = get(selectedWorkshopID);
  let userID;
  if (userLocal.loggedIn) {
    userID = userLocal.uid;
  }
  const userWorkshopPath = `users/${userID}/workshops`;
  return onSnapshot(doc(db, userWorkshopPath, workshopID), (doc) => {
    doc.exists && activeWorkshop.set(doc.data());
  });
};

export const activeLessonUnsub = (lesson) => {
  console.log("first part of unsub function");
  const lessonsPath = "services/workshops/lessons";
  return onSnapshot(doc(db, lessonsPath, lesson.lessonID), (doc) => {
    console.log("second part");
    doc.exists && activeLesson.set(doc.data());
  });
};

export const addUserToWorkshopCloud = httpsCallable(
  functions,
  "addUserToWorkshop"
);

export const syncContactClient = async (contact) => {
  await syncContactServer(contact);
};

export const logout = async () => {
  await signOut(auth);
};

export const monitorAuthState = async () => {
  onAuthStateChanged(auth, (userLocal) => {
    if (userLocal) {
      console.log("You logged in.");
      const userToSet = {
        loggedIn: true,
        ...userLocal,
      };
      user.set(userToSet);
    } else {
      user.set({ loggedIn: false });
    }
  });
};

export const setLessonCompletion = async (lesson, bool) => {
  const userLocal = get(user);
  const workshopID = get(selectedWorkshopID);
  let userID;
  if (userLocal.loggedIn) {
    userID = userLocal.uid;
  }
  const userWorkshopPath = `users/${userID}/workshops`;
  const userWorkshopRef = doc(db, userWorkshopPath, workshopID);
  return await updateDoc(userWorkshopRef, {
    [`modules.${lesson.moduleID}.lessons.${lesson.lessonID}.isComplete`]: bool,
  });
};
